var map = {
	"./360.json": [
		1457,
		13
	],
	"./atlantic-secondary.json": [
		1458,
		14
	],
	"./atlantic.json": [
		1459,
		15
	],
	"./captions-2-language.json": [
		1460,
		16
	],
	"./captions-many-language.json": [
		1461,
		17
	],
	"./captions.json": [
		1462,
		18
	],
	"./connected-to-the-top.json": [
		1463,
		19
	],
	"./cuepoint-timeline-title.json": [
		1464,
		20
	],
	"./custom-colors.json": [
		1465,
		21
	],
	"./custom-icon-jpg.json": [
		1466,
		22
	],
	"./custom-icon-png.json": [
		1467,
		23
	],
	"./custom-icon.json": [
		1468,
		24
	],
	"./custom-story-cover-png.json": [
		1469,
		25
	],
	"./custom-story-cover-svg.json": [
		1470,
		26
	],
	"./custom-view-story-button-text.json": [
		1471,
		27
	],
	"./deep-pathfinder.json": [
		1472,
		28
	],
	"./externalCallbacks.json": [
		1473,
		29
	],
	"./generic-avatar-image.json": [
		1474,
		30
	],
	"./generic-avatar.json": [
		1475,
		31
	],
	"./initial-ad-timeout.json": [
		1476,
		32
	],
	"./initial-ad-transitions.json": [
		1477,
		33
	],
	"./initial-ad-vpaid.json": [
		1478,
		34
	],
	"./initial-ad.json": [
		1479,
		35
	],
	"./limit-streaming.json": [
		1480,
		36
	],
	"./linkless-hotspots.json": [
		1481,
		37
	],
	"./long-story-title.json": [
		1482,
		38
	],
	"./loop-audio.json": [
		1483,
		39
	],
	"./midroll-ad.json": [
		1484,
		40
	],
	"./minimal-story-cover.json": [
		1485,
		41
	],
	"./nergia.json": [
		1486,
		42
	],
	"./new-encoding.json": [
		1487,
		43
	],
	"./no-author.json": [
		1488,
		44
	],
	"./no-hotspots.json": [
		1489,
		45
	],
	"./overlapping-hotspots.json": [
		1490,
		46
	],
	"./pathfinder-image-only-loop.json": [
		1491,
		47
	],
	"./pathfinder-no-hotspots.json": [
		1492,
		48
	],
	"./pathfinder-no-intro-video.json": [
		1493,
		49
	],
	"./pathfinder-subchapter.json": [
		1494,
		50
	],
	"./pathfinder-vertical-loop.json": [
		1495,
		51
	],
	"./pathfinder.json": [
		1496,
		52
	],
	"./permissions.json": [
		1497,
		53
	],
	"./pet-gallery.json": [
		1498,
		54
	],
	"./subchapter-pathfinder.json": [
		1499,
		55
	],
	"./tag-hotspot-overlap-0-and-100.json": [
		1500,
		56
	],
	"./tag-hotspot-overlap-1.json": [
		1501,
		57
	],
	"./tag-hotspot-overlap-all-same-position.json": [
		1502,
		58
	],
	"./tag-hotspot-overlap-all-same-top.json": [
		1503,
		59
	],
	"./vertical-video.json": [
		1504,
		60
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1236;
module.exports = webpackAsyncContext;